/// <reference path="./global.d.ts" />

/*!
 * @preserve
 * DownloadZeitRechner.js
 * Download-Zeit JS Frontend Library for dein-ip-check.de
 *
 * @author Jens Dutzi <jens.dutzi@tf-network.de>
 * @website http://www.dein-ip-check.de
 * @license Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 */

interface speedDetails {
    name: any,
    download: number,
    upload: number
}

// Geschwindigkeits-Optionen
const speed: { [key: string]: speedDetails } = {
    "s1"            : { "name" : "ADSL2+ (16 Mbit/s)",  "download": 16384,  "upload": 2457 },
    "s2"            : { "name" : "VDSL (50 Mbit/s)",    "download": 51200,  "upload": 10240 },
    "s3"            : { "name" : "VDSL (100 Mbit/s)",   "download": 102400, "upload": 40960 },
    "s4"            : { "name" : "VDSL (250 Mbit/s)",   "download": 256000, "upload": 40960 },
    "s5"            : { "name" : DOWNLOADZEITSTRINGS["Kabel"] + " (100 Mbit/s)",  "download": 102400, "upload": 5120 },
    "s6"            : { "name" : DOWNLOADZEITSTRINGS["Kabel"] + " (120 Mbit/s)",  "download": 122880, "upload": 6144 },
    "s7"            : { "name" : DOWNLOADZEITSTRINGS["Kabel"] + " (200 Mbit/s)",  "download": 204800, "upload": 5120 },
    "s8"            : { "name" : DOWNLOADZEITSTRINGS["Kabel"] + " (400 Mbit/s)",  "download": 409600, "upload": 20480 },
    "s9"            : { "name" : DOWNLOADZEITSTRINGS["Kabel"] + " (1 Gbit/s)",    "download": 1024000, "upload": 51200 },
    "userdefiend"   : { "name" : DOWNLOADZEITSTRINGS["Benutzerdefiniert"],        "download": 0,      "upload": 0 }
};

window.onload = () => {
    // Numerals laden zur Formatierung von Zahlen
    let numeral = require("numeral");
    require("numeral/locales");

    // Setze Sprache anhand des html-lang Tags
    if( DOWNLOADZEITLANGUAGE == "en" ) {
        // noinspection TypeScriptValidateJSTypes
        numeral.locale("en-gb");
    } else {
        // noinspection TypeScriptValidateJSTypes
        numeral.locale("de");
    }

    // Wichtige Felder ermitteln
    let frmIdZugangsart = $(".mod_DownloadZeit select[name=zugangsart]").attr("id");
    let frmIdAuslastung = $(".mod_DownloadZeit select[name=auslastung]").attr("id");
    const defaultSpeed = "s3";

    // Fülle voreingestellte Liste mit Zugangsarten
    let formZugangsart = $("#" + frmIdZugangsart);
    formZugangsart.empty();
    $.each(speed, function(key, value) {
        let option = new Option(value["name"], key.toString());
        if(key === defaultSpeed) option.selected = true;
        formZugangsart.append( option );
    });

    // Fülle Auslastungs-Auswahl
    let formAuslastung = $(`#${frmIdAuslastung}`);
    formAuslastung.empty();
    for (let i = 1; i <= 10; i++) {
        let auslastung = new Option( i.toString() + "0%", (i*10).toString() );
        if(i === 10) auslastung.selected = true;
        formAuslastung.append(auslastung);
    }

    // aktualisiere Geschwindigkeits-Auswahl
    updateGeschwindigkeit(defaultSpeed, "100");

    // Formular aktualisieren bei Änderung der Zugangsart oder Auslastung
    $(".updateFormOnChange").on("change", function() {
        updateGeschwindigkeit(
            $("#" + frmIdZugangsart).val().toString(),
            $("#" + frmIdAuslastung).val().toString()
        );
    });

    // Formular zurücksetzen
    $("#reset").on("click", function() {
        $("#error").hide();
        $(".downloadZeitErgebnis").hide();
        $("input[name=DownloadSize]").val("");
        $("select[name=DownloadSizeMetrics]").val("mb");
        $("select[name=zugangsart]").val(defaultSpeed);
        $("select[name=auslastung]").val("100");
        updateGeschwindigkeit(defaultSpeed, "100");

        return false;
    });

    // Berechnung auslösen
    $("#downloadRechnerFormular").on("submit", function() {
        $("#error").hide();
        $(".downloadZeitErgebnis").hide();
        calcDownloadTime();
        return false;
    }).show();

    /**
     * Berechnen der Download-Zeit
     */
    function calcDownloadTime(): void {
        let uploadSpeed:number, downloadSpeed: number;
        let zugangsArt = $("select[name=zugangsart]").val().toString();
        let downloadZeitErgebnis = $(".downloadZeitErgebnis");

        if(zugangsArt === "userdefiend") {
            // Userdefinied Wert direkt übernehmen
            downloadSpeed = numeral( $("input[name=userDownload]").val() ).value();
            uploadSpeed = numeral( $("input[name=userUpload]").val() ).value();
        } else {
            // gewählte vorgewählte Zugangsart
            downloadSpeed = speed[zugangsArt]["download"];
            uploadSpeed = speed[zugangsArt]["upload"];
        }

        // Auslastung einberechnen
        let auslastungFaktor:number = numeral( $("#" + frmIdAuslastung).val().toString() ).value() / 100;
        if(isNaN(auslastungFaktor) || auslastungFaktor === null ) {
            console.warn("Auslastungs-Faktor konnte nicht verarbeitet werden");
            auslastungFaktor = 1;
        }
        downloadSpeed = downloadSpeed * auslastungFaktor;
        uploadSpeed = uploadSpeed * auslastungFaktor;

        // Keine Geschwindigkeit angegeben?
        if(downloadSpeed <= 0 || uploadSpeed <= 0) {
            // noinspection JSNonASCIINames
            $("#errorText").html(DOWNLOADZEITSTRINGS["Upload und/oder Download-Geschwindigkeit muss größer als 0 kbit/s sein."]);
            $("#error").show();
            downloadZeitErgebnis.hide();
            return;
        }

        // Download-Size angegeben und gültig?
        let frmDownloadSize = $("input[name=DownloadSize]");
        if(frmDownloadSize.length === 0) {
            // Keine Downloadgröße angegeben
            $("#error").show();
            // noinspection JSNonASCIINames
            $("#errorText").html(DOWNLOADZEITSTRINGS["Sie haben keine Dateigröße angegeben."]);
            downloadZeitErgebnis.hide();
            return;
        }

        let downloadSize: number = numeral( frmDownloadSize.val().toString() ).value();
        if(!numeral.validate(frmDownloadSize.val().toString()) || isNaN(downloadSize) || downloadSize === null) {
            // Keine gültige Zahl eingegeben
            $("#error").show();
            // noinspection JSNonASCIINames
            $("#errorText").html(DOWNLOADZEITSTRINGS["Dateigröße darf ausschließlich Zahlen enthalten."]);
            downloadZeitErgebnis.hide();
            return;
        }

        // Ausgabe-Format gewählt?
        let validFormat:string[] = ["kb","mb", "gb"];
        let downloadsizeFormat:string = $("select[name=DownloadSizeMetrics]").val().toString();
        if(jQuery.inArray(downloadsizeFormat, validFormat) === -1) {
            // Ungültige Einheit gewählt
            $("#error").show();
            // noinspection JSNonASCIINames
            $("#errorText").html(DOWNLOADZEITSTRINGS["Ungültige Einheit für die Download-Größe gewählt."]);
            downloadZeitErgebnis.hide();
            return;
        }

        /*
         * Berechnung durchführen
         */
        // Download-Größe in kbyte umrechnen
        let downloadSizeKbyte:number;
        switch(downloadsizeFormat) {
            case "mb":
                downloadSizeKbyte = downloadSize * 1024;
                break;
            case "gb":
                downloadSizeKbyte = downloadSize * 1024 * 1024;
                break;
            default:
                downloadSizeKbyte = downloadSize;
        }

        // Download-Geschwwindigkeit umwandeln
        let downloadSpeedKbyte:number = downloadSpeed / 8;
        let uploadSpeedKbyte:number = uploadSpeed / 8;

        // Laufzeit in Sekunden berechnen
        let downloadZeit:number = Math.round(downloadSizeKbyte / downloadSpeedKbyte);
        let uploadZeit:number = Math.round(downloadSizeKbyte / uploadSpeedKbyte);

        /*
         * Ergebnis
         */
        //$("#downloadRechnerEingabe").hide();
        downloadZeitErgebnis.show();

        $("#ergebnisDownloadSize").text( `${numeral(downloadSizeKbyte).format("0,0")} kByte` );
        $("#ergebnisZugangsart").text( speed[zugangsArt]["name"] );

        $("#ergebnisDownloadSpeed").text( `${numeral(downloadSpeedKbyte).format("0,0")} kByte/s` );
        $("#ergebnisUploadSpeed").text( `${numeral(uploadSpeedKbyte).format("0,0")} kByte/s` );

        $("#ergebnisDownloadTime").text( formatDownloadTime(downloadZeit) );
        $("#ergebnisUploadTime").text( formatDownloadTime(uploadZeit) );
    }

    /**
     * Aktualisiere die Geschwindigkeits-Anzeige
     *
     * @param selectedSpeed
     * @param userAuslastung
     */
    function updateGeschwindigkeit(selectedSpeed:string, userAuslastung:string): void {
        // Ermittle Feld-IDs anhand der Namen
        let frmUserDownload = $("#" + $("input[name=userDownload]").attr("id") );
        let frmUserUpload   = $("#" + $("input[name=userUpload]").attr("id") );

        // Ermittle Geschwindigkeits-Daten für gewählten Zugang
        let userSpeed = speed[selectedSpeed];

        if(selectedSpeed !== "userdefiend") {
            let faktor = parseInt(userAuslastung) / 100;

            if( userSpeed["download"] >= 10000 ) {
                frmUserDownload.val( numeral(userSpeed["download"] * faktor / 1024).format("0,0") ).prop( "disabled", true );
                frmUserUpload.val( numeral(userSpeed["upload"] * faktor / 1024).format("0,0.0") ).prop( "disabled", true );
                $("label[for='"+ frmUserDownload.attr("id") + "']").text( "Download (Mbit/s)" );
                $("label[for='" + frmUserUpload.attr("id") + "']").text( "Upload (Mbit/s)" );
            } else {
                frmUserDownload.val( numeral(userSpeed["download"] * faktor).format("0,0")  ).prop( "disabled", true );
                frmUserUpload.val( numeral(userSpeed["upload"] * faktor).format("0,0.0") ).prop("disabled", true );
                $("label[for='"+ frmUserDownload.attr("id") + "']").text( "Download (kbit/s)" );
                $("label[for='" + frmUserUpload.attr("id") + "']").text( "Upload (kbit/s)" );
            }
            $("select[name=auslastung]").prop("disabled", false);
        } else {
            // Benutzerdefinierte Geschwindigkeitswahl
            frmUserDownload.val("").prop("disabled", false );
            frmUserUpload.val("").prop("disabled", false );
            $("label[for='"+ frmUserDownload.attr("id") + "']").text( "Download (kbit/s)" );
            $("label[for='" + frmUserUpload.attr("id") + "']").text( "Upload (kbit/s)" );
            $("select[name=auslastung]").prop("disabled", true);
        }
    }

    /**
     * Internal: Umrechnung der Laufzeit von Sekunden in Sekunden/Minuten/Stunden/Tage
     *
     * @param laufzeitSekunden
     * @return string
     */
    function formatDownloadTime(laufzeitSekunden: number): string {
        // gerunderter Wert ermitteln
        laufzeitSekunden = Math.floor(laufzeitSekunden);

        let tage = Math.floor( laufzeitSekunden/60/60/24 );
        let stunden = Math.floor( (laufzeitSekunden/60/60)%24 );
        let minuten = Math.floor( (laufzeitSekunden/60)%60 );
        let sekunden = Math.floor( laufzeitSekunden%60 );

        // String zusammenstellen
        let output: string;

        if(tage > 1) {
            output = tage.toString().concat(` ${DOWNLOADZEITSTRINGS["Tage"]}, `);
        } else if (tage === 1) {
            output = tage.toString().concat(` ${DOWNLOADZEITSTRINGS["Tag"]}, `);
        } else {
            output = ""
        }

        if(stunden > 1) {
            output = output.concat(stunden.toString(), ` ${DOWNLOADZEITSTRINGS["Stunden"]}, `);
        } else if (stunden === 1) {
            output = output.concat(stunden.toString(), ` ${DOWNLOADZEITSTRINGS["Stunde"]}, `);
        }

        if(minuten > 1) {
            output = output.concat(minuten.toString(), ` ${DOWNLOADZEITSTRINGS["Minuten"]}, `);
        } else if (minuten === 1) {
            output = output.concat(minuten.toString(), ` ${DOWNLOADZEITSTRINGS["Minute"]}, `);
        }

        if(sekunden > 1) {
            output = output.concat(sekunden.toString(), ` ${DOWNLOADZEITSTRINGS["Sekunden"]}`);
        } else if (sekunden === 1) {
            output = output.concat(sekunden.toString(), ` ${DOWNLOADZEITSTRINGS["Sekunde"]}`);
        } else {
            if(output.length === 0) output = `0 ${DOWNLOADZEITSTRINGS["Sekunden"]}`;
        }

        return output;
    }
};
